export default __webpack_public_path__ + "static/media/layout-select-img2.a1ca88df.png";